import { useMemo } from 'react'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import type { SubscriberModel } from '@models/types'

const watchEntityKeys = ['subscribers']

type SubscribersFilters = {
  subscribable_id?: number,
  subscribable_type?: string,
}

type UseSubscribersOptions = {
  filters?: SubscribersFilters,
}

function useSubscribers(options: UseSubscribersOptions) {
  const { filters = {} } = options
  const {
    subscribable_id: filterSubscribableId,
    subscribable_type: filterSubscribableType,
  } = filters

  const {
    updatedEntities: { subscribers: subscribersUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { subscribers } = useSelector(reduxState => reduxState.entities)

  const filteredSubscribers = useMemo(() => {
    const filtered = Object.values(subscribers).filter((subscriber: SubscriberModel) => {
      const { subscribable_type, subscribable_id } = subscriber

      const matchSubscribableId = matchFilterNumber(subscribable_id, filterSubscribableId)
      const matchSubscribableType = filterSubscribableType ? filterSubscribableType === subscribable_type : true

      return matchSubscribableId && matchSubscribableType
    })

    return sortArrayBy(filtered, 'asc', 'id')
  }, [subscribersUpdatedAt, JSON.stringify(filters)])

  const filteredSubscribersCount = filteredSubscribers.length
  const hasFilteredSubscribers = !!filteredSubscribers

  return {
    filteredSubscribers,
    filteredSubscribersCount,
    hasFilteredSubscribers,
  }
}

export default useSubscribers
